// Cinematic mission countdown to an application window's opening day.
import { useEffect, useState } from "react";
import { getNow, windowState } from "@/lib/windows";

const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

const remaining = (target, offset) => {
  const ms = target.getTime() - (Date.now() + offset);
  if (ms <= 0) return null;
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor(ms / 3600000) % 24,
    m: Math.floor(ms / 60000) % 60,
    s: Math.floor(ms / 1000) % 60,
  };
};

export const MissionCountdown = ({ kind = "student", label = "Recruitment window opens in" }) => {
  const w = windowState(kind);
  const [t, setT] = useState(null);

  useEffect(() => {
    if (w.status !== "sealed" || !w.open) return;
    const target = new Date(`${w.open}T00:00:00`);
    const offset = getNow().getTime() - Date.now();
    setT(remaining(target, offset));
    const id = setInterval(() => setT(remaining(target, offset)), 1000);
    return () => clearInterval(id);
  }, [w.status, w.open]);

  if (w.status !== "sealed" || !t) return null;

  const units = [
    { v: t.d, u: "Days" },
    { v: t.h, u: "Hrs" },
    { v: t.m, u: "Min" },
    { v: t.s, u: "Sec" },
  ];

  return (
    <div className="inline-block" data-testid={`mission-countdown-${kind}`}>
      <p className="font-mono text-[9px] uppercase tracking-[0.4em] text-gold/80">
        <span className="mr-2 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-gold align-middle" aria-hidden="true" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3">
        {units.map(({ v, u }, i) => (
          <div key={u} className="flex items-start gap-2 sm:gap-3">
            <div className="min-w-[58px] border border-gold/30 bg-onyx/80 px-2 py-2.5 shadow-[inset_0_0_20px_rgba(0,0,0,0.6)] sm:min-w-[70px] sm:px-3 sm:py-3">
              <div className="font-display text-2xl tabular-nums leading-none text-gold-metallic sm:text-4xl" data-testid={`countdown-${u.toLowerCase()}`}>
                {pad(v)}
              </div>
              <div className="mt-1.5 font-mono text-[8px] uppercase tracking-[0.3em] text-silver/50">{u}</div>
            </div>
            {i < units.length - 1 && (
              <span className="mt-2 font-display text-xl leading-none text-gold/40 sm:mt-2.5 sm:text-3xl" aria-hidden="true">:</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
